<div class="modal fade ig-visitas" id="visitasModal" tabindex="-1" aria-labelledby="visitasModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
    <div class="modal-content">
      <header class="ig-visitas__header">
        <div class="ig-visitas__heading">
          <span class="ig-visitas__heading-icon"><i class="fa-solid fa-eye" aria-hidden="true"></i></span>
          <div>
            <h2 class="ig-visitas__title" id="visitasModalLabel">Visitas a tu perfil</h2>
            <p class="ig-visitas__subtitle">Descubre quién se ha interesado por ti y tus mascotas.</p>
          </div>
        </div>
        <button type="button" class="ig-visitas__close" data-bs-dismiss="modal" aria-label="Cerrar visitas">
          <i class="fa-solid fa-xmark" aria-hidden="true"></i>
        </button>
      </header>

      <div class="modal-body ig-visitas__body" #scrollContainerVisitas (scroll)="onScroll($event)">
        <div class="ig-visitas__count" *ngIf="visitas.length">
          <span><i class="fa-solid fa-paw" aria-hidden="true"></i> Visitas recientes</span>
          <span>{{ visitas.length }} mostradas</span>
        </div>

        <div class="ig-visitas__grid" *ngIf="visitas.length">
          <a class="ig-visit" *ngFor="let visita of visitas; trackBy: trackByVisita"
             [href]="visita.slug ? global.urlServer + 'perfil/' + visita.slug : null"
             [class.ig-visit--new]="!visita.vi_vista"
             [attr.aria-label]="'Ver perfil de ' + getNombre(visita)"
             (click)="$event.preventDefault(); goPerfil(visita)">
            <div class="ig-visit__avatars">
              <img class="ig-visit__owner" [src]="visita.foto_principal_thumb || global.urlServer + 'img/default-user.png'"
                   alt="" loading="lazy" />
              <img *ngIf="visita.foto_mascota_thumb" class="ig-visit__pet" [src]="visita.foto_mascota_thumb"
                   alt="" loading="lazy" />
            </div>
            <div class="ig-visit__info">
              <div class="ig-visit__top">
                <strong class="ig-visit__name">{{ getNombre(visita) }}</strong>
                <span class="ig-visit__new" *ngIf="!visita.vi_vista">Nueva</span>
              </div>
              <span class="ig-visit__details" *ngIf="visita.mascota?.ma_sexo || visita.mascota?.edad">
                <i class="fa-solid fa-paw" aria-hidden="true"></i>
                {{ visita.mascota?.ma_sexo }} <span *ngIf="visita.mascota?.edad">· {{ visita.mascota.edad }}</span>
              </span>
              <span class="ig-visit__details" *ngIf="visita.sexo || visita.edad">
                <i class="fa-regular fa-user" aria-hidden="true"></i>
                {{ visita.sexo }} <span *ngIf="visita.edad">· {{ visita.edad }}</span>
              </span>
              <span class="ig-visit__location" *ngIf="visita.ciudad"><i class="fa-solid fa-location-dot" aria-hidden="true"></i> {{ visita.ciudad }}</span>
              <span class="ig-visit__date"><i class="fa-regular fa-clock" aria-hidden="true"></i> {{ visita.vi_fechahora | cuandoFechas }}</span>
            </div>
            <i class="fa-solid fa-chevron-right ig-visit__arrow" aria-hidden="true"></i>
          </a>
        </div>

        <div class="ig-visitas__empty" *ngIf="!load && !error && !visitas.length">
          <span class="ig-visitas__empty-icon"><i class="fa-solid fa-paw" aria-hidden="true"></i></span>
          <h3>Aún no tienes visitas</h3>
          <p>Cuando alguien visite tu perfil, podrás verlo aquí.</p>
        </div>

        <div class="ig-visitas__loading" *ngIf="load || cargandoMas" role="status">
          <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
          <span>{{ load ? 'Cargando visitas…' : 'Cargando más visitas…' }}</span>
        </div>
        <div class="ig-visitas__error" *ngIf="error" role="alert">
          <i class="fa-solid fa-circle-exclamation" aria-hidden="true"></i>
          <span>{{ error }}</span>
          <button type="button" (click)="visitas.length ? cargarVisitasSiguientes() : getVisitas()">Reintentar</button>
        </div>
        <div class="ig-visitas__end" *ngIf="noHayMas && visitas.length && !load && !cargandoMas">No hay más visitas por mostrar</div>
      </div>
      <footer class="ig-visitas__footer">
        <span><i class="fa-solid fa-lock" aria-hidden="true"></i> Solo tú puedes ver esta información</span>
        <button type="button" class="ig-visitas__dismiss" data-bs-dismiss="modal">Cerrar</button>
      </footer>
    </div>
  </div>
</div>
